<div class="app-container">
  <page-header [icon]="'far-shopping-cart'" [title]="'purchase.order.items'">
    <ng-container class="header-button">
      <!--      <btn-->
      <!--        *ngIf="canCreate"-->
      <!--        [routerLink]="['/purchase-order']"-->
      <!--        [label]="'order.create'"-->
      <!--        [title]="'order.create' | translate"-->
      <!--        [classes]="['btn-first', 'float-right']"-->
      <!--        [icon]="'far-plus'"-->
      <!--        data-cy="create-purchase-order"-->
      <!--      ></btn>-->
    </ng-container>
  </page-header>

  <section *ngIf="!userHavePermissionForThisPage" class="content max-width-80">
    <loading-spinner [isLoading]="loading"></loading-spinner>
    {{ 'purchasePrice.textForUsersWithoutPermission' | translate }}
  </section>

  <section class="content" *ngIf="userHavePermissionForThisPage">
    <app-filter-form
      [isExportButtonShown]="false"
      [filters]="queryFilters"
      [entity]="'purchaseOrderItems'"
      [filterVisible]="filters.expanded"
      [isFilterInvisible]="true"
      (onSubmit)="filter()"
      (onClearClick)="clearFilters()"
      (onExportResult)="filter()"
      (filterVisibleChange)="filters.expanded = $event"
    >
      <div class="container-fluid pl-0 pr-0">
        <!--      FIRST ROW OF INPUTS-->
        <div class="row">
          <div class="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
            <form-row-input
              [label]="'products.fulltext'"
              [icon]="null"
              [(model)]="filters.fulltext"
              (keyup.enter)="filter()"
              data-cy="order-name-filter"
            ></form-row-input>
          </div>
          <div class="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
            <form-row-select
              [label]="'products.suppliers'"
              [icon]="null"
              [(model)]="filters.supplier"
              [options]="suppliers"
              data-cy="order-process-filter"
            ></form-row-select>
          </div>
          <div class="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
            <form-row-select
              [label]="'purchase.depot-to'"
              [icon]="null"
              [(model)]="filters.depot"
              [options]="depots"
              data-cy="order-process-filter"
            ></form-row-select>
          </div>
        </div>
        <!--      SECOND ROW OF INPUTS-->
        <!--        <div class="dropdown" [ngClass]="{ open: filters.expanded }">-->
        <!--          <div class="row">-->
        <!--            <div class="col-12 col-sm-4 col-md-2 col-lg-2 col-xl-2">-->
        <!--              <form-row-input-->
        <!--                [label]="'purchase.expected-from'"-->
        <!--                [icon]="null"-->
        <!--                [inputType]="'date'"-->
        <!--                [(model)]="filters.dateEstimatedArrivalFrom"-->
        <!--              ></form-row-input>-->
        <!--            </div>-->
        <!--            <div class="col-12 col-sm-4 col-md-2 col-lg-2 col-xl-2">-->
        <!--              <form-row-input-->
        <!--                [label]="'purchase.expected-to'"-->
        <!--                [icon]="null"-->
        <!--                [inputType]="'date'"-->
        <!--                [(model)]="filters.dateEstimatedArrivalTo"-->
        <!--              ></form-row-input>-->
        <!--            </div>-->
        <!--            <div class="col-12 col-sm-4 col-md-2 col-lg-2 col-xl-2">-->
        <!--              <form-row-select-multiple-->
        <!--                [label]="'tags'"-->
        <!--                [options]="tags"-->
        <!--                [(selectedValues)]="filters.tags"-->
        <!--              ></form-row-select-multiple>-->
        <!--            </div>-->

        <!--          </div>-->
        <!--        </div>-->
      </div>
    </app-filter-form>
    <app-base-listing
      #baseListingComponent
      [storageKey]="storageKey"
      [loadingNextItems]="loading"
      [loadingItems]="reloading"
      [items]="purchaseOrderItems"
      [columns]="listingColumns"
      [totalItems]="totalItems"
      [currentPage]="currentPage"
      [endPage]="endPage"
      [(sortProp)]="filters.sortProp"
      [(sortDir)]="filters.sortDir"
      [listName]="'purchaseOrderItems'"
      (reloadList)="filter()"
      (switchPage)="filter($event.currentPage, $event.sortProp, $event.sortDir, $event.concat)"
      (callAction)="callAction($event)"
    ></app-base-listing>
  </section>
</div>
